import { Box, Stack } from "@mui/joy";

import { Route } from "../../core/types";
import { MapRoutePinUnplacedSvg } from "./MapRoutePinSvg";

type Props = {
  routes: (Partial<Route> & { uuid: string })[];
  onClick?: (uuid: string) => void;
  onContextMenu?: (uuid: string, x: number, y: number) => void;
};

export default function UnplacedRoutesDrawer({ routes, onClick, onContextMenu }: Props) {
  return (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        top: "20px",
        display: "flex",
        zIndex: 10,
        borderRadius: "0 8px 8px 0",
        overflow: "hidden",
        border: "1px solid",
        borderColor: "neutral.700",
      }}
      className="unplaced-routes"
    >
      <Stack
        sx={{
          backgroundColor: "neutral.800",
          padding: 0.75,
          gap: 1,
        }}
      >
        {routes.map((route) => (
          <MapRoutePinUnplacedSvg
            route={route}
            onClick={(e) => {
              e.stopPropagation();
              onClick?.(route.uuid);
            }}
            key={route.uuid}
            onContextMenu={(e) => {
              e.preventDefault();
              onContextMenu?.(route.uuid, e.clientX, e.clientY);
            }}
          />
        ))}
      </Stack>
      <Stack
        sx={{
          backgroundColor: "neutral.800",
          alignItems: "center",
          paddingY: 0.5,
        }}
        spacing={0.25}
      >
        <Box
          sx={{
            whiteSpace: "nowrap",
            width: 28,
            height: 62,
          }}
        >
          <Box
            sx={{
              display: "inline-flex",
              transform: "translateX(-100%) rotate(-90deg)",
              height: 30,
              alignItems: "center",
              position: "relative",
              zIndex: 2,
              color: "neutral.100",
              transformOrigin: "top right",
              fontSize: "sm",
              fontWeight: "bold",
            }}
          >
            Unplaced
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
